import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { RiDeleteBin6Line } from 'react-icons/ri';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { HiOutlineViewGrid } from 'react-icons/hi';

const BookList = ({setLoading}) => {
const [books, setBooks] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [showDelete, setShowDelete] = useState(false);
const [selectedBook, setSelectedBook] = useState('');
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [showView, setShowView] = useState(false);

               const fetchBooks = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/libget-books');
        
                        if (response.ok) {
                            const data = await response.json();
                            setBooks(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }


         useEffect(() => {
      fetchBooks();
    }, []);


      const filteredBook = books.filter(book => {
  const term = searchTerm.toLowerCase();
  return (
    book.title.toLowerCase().includes(term) ||
    book.category.toLowerCase().includes(term) ||
    book.subject.toLowerCase().includes(term) ||
        book.rack_no.toLowerCase().includes(term)
  );
});


    const handleShowDelete = (book) => {
    setSelectedBook(book);
    setShowDelete(true);
  }

  const handleView = (book) => {
  setSelectedBook(book);
  setShowView(true);
};

              const handleDelete = async (bId) => {
    try {
      const response = await fetch(`https://api.kcian.in/libdelete-book/${bId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setBooks((prevData) => prevData.filter((product) => product.id !== bId));
        setShowDelete(false);
        setResponse2({ message: 'Book Removed from Library!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting:', error);
    }
  };



    return (
        <>
        <section className='py-4'>
            <div className='px-4'>
                <HeadingArea message1='Library' message2='Book List' />

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

{!showView &&
                    <div className='profile-card py-2'>

                        <div className='d-md-flex d-sm-flex justify-content-between mb-2'>

                            <div className='profile-input-area ms-auto col-lg-4 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search title, Rack, Category, Subject'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
                            </div>
                        </div>

                        <div className="table-responsive mt-4">
                            <table className="table w-100">
                                <thead className="account-thead rounded-4">

                                    <th className='rounded-start-4'>S No</th>
                                    <th>Title/ Book No</th>
                                    {/* <th>ISBN No</th> */}
                                    <th>Category/ Subject</th>
                                    <th>Publisher</th>
                                    {/* <th>Author</th> */}
                                    <th>Rack No</th>
                                    <th>Qty</th>
                                    <th>Price</th>
                                    {/* <th>Details</th> */}
                                    <th className='rounded-end-4'>Activity</th>

                                </thead>
                                <tbody>

    {filteredBook.map((book, index) => (
      <tr className='account-tr' key={book.id}>
        <td>{index + 1}</td>
        <td>{book.title}/ {book.book_no}</td>
        {/* <td>{book.isbn_no || '--'}</td> */}
        <td>{book.category}/ {book.subject}</td>
        <td>{book.publisher || '--'}</td>
        {/* <td>{book.author || '--'}</td> */}
        <td>{book.rack_no || '--'}</td>
        <td>{book.qty || '--'}</td>
        <td>₹{book.price || '--'}</td>
        {/* <td>{book.description || '--'}</td> */}
        <td>
          <HiOutlineViewGrid className='account-icon2 me-2' title='View' onClick={() => handleView(book)} />

          <RiDeleteBin6Line className='account-icon1' onClick={() => handleShowDelete(book)} />
        </td>
      </tr>
    ))}


                                </tbody>
                            </table>
                        </div>

            
            
            
                </div>
}

{showView && selectedBook && (
  <section
    className="ins-dialog"
    onClick={() => setShowView(false)}
  >
    <div
      className="ins-dialog-inner col-lg-8 col-12 animate__animated animate__fadeInDown mx-auto"
      onClick={(e) => e.stopPropagation()}
    >

        <div className="d-flex justify-content-between">
        <p className="profile-heading my-0">
        Book Details
        </p>

                  <button className='profile-btn2' onClick={() => setShowView(false)}>Go Back</button>

      </div>

      <div className="row mt-3">

<div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Title</label>      
     <span>{selectedBook.title || '--'}</span>
</div>        </div>

<div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Price</label>      
          <span>₹{selectedBook.price || '--'}</span>
</div>        </div>

<div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Book No</label>      
          <span>{selectedBook.book_no || '--'}</span>
        </div>
        </div>

<div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">ISBN No</label>               <span>{selectedBook.isbn_no || '--'}</span>
        </div>
        </div>

<div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Category</label>               <span>{selectedBook.category || '--'}</span>
        </div>
        </div>

<div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Subject</label>          <span>{selectedBook.subject || '--'}</span>
        </div>
        </div>

<div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Author</label>          <span>{selectedBook.author || '--'}</span>
        </div>
        </div>



       <div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Publisher</label>
          <span>{selectedBook.publisher || '--'}</span>
        </div>
        </div>


          <div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Rack No</label>
          <span>{selectedBook.rack_no || '--'}</span>
        </div>        </div>


    <div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Quantity</label>          <span>{selectedBook.qty || '--'}</span>
        </div>        </div>


    <div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Issued Qty</label>          <span>{selectedBook.issue_qty || '--'}</span>
        </div>        </div>


    <div className='col-md-6 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Available Qty</label>          <span>{(selectedBook.qty - selectedBook.issue_qty) || '--'}</span>
        </div>        </div>


       

    <div className='col-md-12 mb-4'>
        <div className="profile-input-area align-content-center p-3">
 <label className="profile-badge">Description</label>          <p>{selectedBook.description || '--'}</p>
        </div>
        </div>

      </div>

   
    </div>
  </section>
)}

            </div>
        </section>


          {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Book!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
      <th className='rounded-start-4'>Title/ Book No</th>
                                    <th>ISBN No</th>
                                    <th>Category/ Subject</th>
                                    <th>Publisher</th>
                                    <th>Author</th>
                                    <th>Rack No</th>
                                    <th>Qty</th>
                                    <th>Price</th>
      <th className='rounded-end-4'>Details</th>
</thead>

<tr className='account-tr'>
        <td>{selectedBook.title}/ {selectedBook.book_no}</td>
        <td>{selectedBook.isbn_no || '--'}</td>
        <td>{selectedBook.category}/ {selectedBook.subject}</td>
        <td>{selectedBook.publisher || '--'}</td>
        <td>{selectedBook.author || '--'}</td>
        <td>{selectedBook.rack_no || '--'}</td>
        <td>{selectedBook.qty || '--'}</td>
        <td>₹{selectedBook.price || '--'}</td>
        <td>{selectedBook.description || '--'}</td>
</tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Book will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedBook.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

</>
    )
}

export default BookList